/*
 * Calmo - link "Ustawienia cookies" w stopce.
 *
 * Po co: Prawo komunikacji elektronicznej i RODO wymagaja, zeby wycofanie zgody
 * bylo tak samo latwe jak jej udzielenie. Baner cookies Shopify pokazuje sie tylko
 * przy pierwszej wizycie, wiec bez takiego linku pozniejsza zmiana decyzji jest
 * praktycznie niemozliwa.
 *
 * Jak dziala: link dodaje sie sam do stopki i otwiera okno preferencji Shopify.
 * Jesli baner cookies nie jest wlaczony w panelu (Ustawienia > Prywatnosc klienta),
 * skrypt nie robi nic i nie dodaje martwego linku.
 */
(function () {
  'use strict';

  var LABEL = 'Ustawienia cookies';
  var MAX_TRIES = 20;
  var tries = 0;

  function openPreferences(event) {
    event.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      window.Shopify.customerPrivacy.showPreferences();
    }
  }

  function bannerAvailable() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return true;
    }
    return !!(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    );
  }

  function findFooterTarget() {
    return (
      document.querySelector('.footer__content-bottom .policies') ||
      document.querySelector('.footer__content-bottom .footer__copyright') ||
      document.querySelector('.footer__content-bottom') ||
      document.querySelector('.footer')
    );
  }

  function addLink() {
    if (document.querySelector('[data-calmo-cookie-settings]')) return true;

    var target = findFooterTarget();
    if (!target) return false;

    var wrapper = document.createElement('div');
    wrapper.setAttribute('data-calmo-cookie-settings', '');
    wrapper.style.marginTop = '0.8rem';
    wrapper.style.fontSize = '1.3rem';

    var link = document.createElement('a');
    link.href = '#';
    link.textContent = LABEL;
    link.className = 'link link--text';
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', openPreferences);

    wrapper.appendChild(link);
    target.appendChild(wrapper);
    return true;
  }

  function attempt() {
    tries += 1;

    if (bannerAvailable()) {
      addLink();
      return;
    }

    if (tries < MAX_TRIES) {
      window.setTimeout(attempt, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt, { once: true });
  } else {
    attempt();
  }
})();
